<template>
  <div>
    <a-menu mode="inline" :selectedKeys="[active]" class="mobile-menu">
      <div v-for="(item, index) in dataMenu" :key="index">
        <a-sub-menu v-if="item.children && item.children.length" :key="item.id">
          <template #title>
            <span>
              <i v-if="item.icon" :class="item.icon"></i>
              {{ item.linkLabel }}
            </span>
          </template>

          <!-- CHILD -->
          <div v-for="child in item.children" :key="child.id">

            <!-- CHILD CÓ SUB -->
            <a-sub-menu v-if="child.children && child.children.length" :key="child.id">
              <template #title>
                {{ child.linkLabel }}
              </template>

              <a-menu-item v-for="sub in child.children" :key="sub.linkTo" @click="go(sub.linkTo)">
                {{ sub.linkLabel }}
              </a-menu-item>

            </a-sub-menu>

            <!-- CHILD KHÔNG SUB -->
            <a-menu-item v-else :key="child.linkTo" @click="go(child.linkTo)">
              {{ child.linkLabel }}
            </a-menu-item>

          </div>
        </a-sub-menu>

        <!-- MENU KHÔNG CHILD -->
        <a-menu-item v-else :key="item.linkTo" @click="go(item.linkTo)">
          <i v-if="item.icon" :class="item.icon"></i>
          {{ item.linkLabel }}
        </a-menu-item>

      </div>
    </a-menu>
    <!-- <div class="nav-fotter-mb">
      <div class="login-slide">
        <div class="btn-gift-login" v-if="isLogin == false">
          <div @click="loginUser">{{ $t("text.login") }}</div>
        </div>
        <div class="mt-4" v-if="isLogin == false">
          {{ $t("text.haveAccount") }}&ensp;
          <a class="lable-text" @click="registerForm">{{ $t("text.register") }}</a>
        </div>
        <div class="user-logout" @click="logOut" v-if="isLogin == true">
          <i class="fa-solid fa-arrow-right-from-bracket"></i> {{ $t('loginForm.logout') }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import store from '@/store';
import commons from '@/utils/Common';
import { ref, computed, watch } from 'vue';
import { useRouter } from 'vue-router'

interface Props {
  dataMenu: any[]
}

const props = withDefaults(defineProps<Props>(), {
  dataMenu: () => []
})
const isLogin = ref(false)
const router = useRouter()
const active = router.currentRoute.value.path

const go = (path: string) => {
  router.push(path)
}

</script>

<style scoped>
.mobile-menu {
  border-right: none;
  background: var(--primary-dark);
  color: var(--text-white);
  padding: 8px 0;
}

.mobile-menu :deep(.ant-menu-item),
.mobile-menu :deep(.ant-menu-submenu-title) {
  height: 46px;
  line-height: 46px;
  margin: 0;
  padding: 0 16px;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 600;
}

.mobile-menu :deep(.ant-menu-item i),
.mobile-menu :deep(.ant-menu-submenu-title i) {
  color: var(--default-header-color);
  margin-right: 10px;
  font-size: 16px;
}

.mobile-menu :deep(.ant-menu-submenu-arrow) {
  color: rgba(255, 255, 255, 0.75);
}

.mobile-menu :deep(.ant-menu-item:hover),
.mobile-menu :deep(.ant-menu-submenu-title:hover) {
  color: var(--text-white);
  background: rgba(255, 255, 255, 0.06);
  font-size: 17px;
}

.mobile-menu :deep(.ant-menu-item:hover a),
.mobile-menu :deep(.ant-menu-submenu-title:hover a),
.mobile-menu :deep(.ant-menu-item-active),
.mobile-menu :deep(.ant-menu-submenu-active > .ant-menu-submenu-title) {
  color: var(--text-white) !important;
}

.mobile-menu :deep(.ant-menu-item-selected) {
  background: rgba(177, 150, 99, 0.12);
  /* border-left: 3px solid var(--default-header-color); */
  padding-left: 13px;
  /* 16px - 3px border */
  font-size: 17px;

}

.mobile-menu :deep(.ant-menu-item::after) {
  border-right: 0;
}

.mobile-menu :deep(.ant-menu-item-selected),
.mobile-menu :deep(.ant-menu-item-selected a) {
  color: var(--default-header-color);
}

.mobile-menu :deep(.ant-menu-sub) {
  background: color-mix(in srgb, var(--primary-dark), #ffffff 6%);
}

.nav-fotter-mb a {
  color: #005425;
  font-weight: 700;
  text-decoration: none;
}

.nav-fotter-mb {
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
}

.btn-get-gift {
  width: 60%;
  max-width: 200px;
}

.btn-get-gift:hover {
  cursor: pointer;
  text-decoration: underline;
}

.btn-gift-login {
  /* box-shadow: 0 3px 2px 0.2px rgba(0, 59, 26, 0.70); */
  border: 1px solid #d4af37;
  color: #FFF;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  padding: 10px;
  border-radius: 25px;
  width: 60%;
}

.login-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>